export const APP_STORE_URL: string | null = null;

export const PLATFORMS_LINE = 'PC, PlayStation, Xbox, Nintendo Switch, iOS and Android';
